module.exports = __webpack_public_path__ + "img/Avatar-35.238dcbd4.svg";